import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { obterListagemPedido } from '../../redux/actions/PedidoAction';
import { Loading, CardPedido, CardErro, Header, Body } from '../../presentations';
import { PaginaEnum, MenuEnum } from '../../enums';
import LogService from '../../services/LogService';
import { Grid } from '@material-ui/core';

function ListagemPedidoPage(
    {
        obterListagemPedido,

        listagem_pedido_loading,
        listagem_pedido,
        listagem_pedido_erro
    }
) {
    useEffect(() => {
        LogService.registrarAcesso(PaginaEnum.MEUS_CARROS, PaginaEnum.properties[PaginaEnum.MEUS_CARROS].acesso);
    }, []);

    useEffect(() => {
        listagem_pedido === null && obterListagemPedido();
    }, [listagem_pedido, obterListagemPedido]);

    return (
        <>
            <Header titulo='Meus carros'
                link={MenuEnum.properties[MenuEnum.HOME].path} />
            <Body>
                {
                    (() => {
                        if (listagem_pedido_loading === null ||
                            listagem_pedido_loading === true)
                            return <Loading />

                        if (listagem_pedido_erro !== null)
                            return <CardErro />

                        if (listagem_pedido.length > 0) {
                            return <Grid container
                                spacing={2}>
                                {
                                    listagem_pedido.map((pedido, index) =>
                                        <Grid key={index}
                                            item
                                            xs={12}
                                            sm={4}>
                                            <CardPedido key={pedido.codigo}
                                                pedido={pedido} />
                                        </Grid>
                                    )
                                }
                            </Grid>
                        }
                    })()
                }
            </Body>
        </>
    );
}

const mapStateToProps = (state) => ({
    listagem_pedido_loading: state.pedido.listagem_pedido_loading,
    listagem_pedido: state.pedido.listagem_pedido,
    listagem_pedido_erro: state.pedido.listagem_pedido_erro
});

const mapDispatchToProps = {
    obterListagemPedido
};

export default connect(mapStateToProps, mapDispatchToProps)(ListagemPedidoPage);